import CryptoJS from "crypto-js";

const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;
const IV = process.env.REACT_APP_IV;

const Criptografia = {
    CriptografarID(id) {
        if (!id) return null;

        const key = CryptoJS.enc.Utf8.parse(SECRET_KEY);
        const iv = CryptoJS.enc.Utf8.parse(IV);

        const encrypted = CryptoJS.AES.encrypt(
            CryptoJS.enc.Utf8.parse(id.toString()),
            key,
            {
                iv: iv,
                padding: CryptoJS.pad.Pkcs7,
                mode: CryptoJS.mode.CBC
            }
        );

        let base64 = encrypted.ciphertext.toString(CryptoJS.enc.Base64);

        let base64url = base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');

        return base64url;
    },

    DescriptografarID(idCriptografado) {
        if (!idCriptografado) return null;

        let base64 = idCriptografado.replace(/-/g, '+').replace(/_/g, '/');
        while (base64.length % 4) {
            base64 += '=';
        }

        const encryptedData = CryptoJS.enc.Base64.parse(base64);
        const key = CryptoJS.enc.Utf8.parse(SECRET_KEY);
        const iv = CryptoJS.enc.Utf8.parse(IV);

        const decrypted = CryptoJS.AES.decrypt(
            { ciphertext: encryptedData },
            key,
            {
                iv: iv,
                padding: CryptoJS.pad.Pkcs7,
                mode: CryptoJS.mode.CBC
            }
        );

        const result = decrypted.toString(CryptoJS.enc.Utf8);
        return isNaN(result) ? result : parseInt(result, 10);
    },

    CriptografarVariosID(ids) {
        const encryptedIds = ids.map(id => this.CriptografarID(id)).filter(Boolean);
        return encryptedIds.join(";");
    },

    DescriptografarVariosID(idsCriptografados) {
        const ids = idsCriptografados.split(";");
        return ids.map(id => this.DescriptografarID(id)).filter(Boolean);
    }
};

export default Criptografia;